import { getToken } from './authUtils';
import ServicioURLManager from './servicioUrlManager';

/**
 * ## Función: fetchClientesDesdeAPI
 * Realiza una solicitud al endpoint /getCuentas para obtener la lista de clientes filtrados.
 *
 * ## Versión: 1.1.0
 *
 * @param {string} [busqueda=""] - Texto para filtrar clientes por nombre u otro criterio.
 * @returns {Promise<Client[]>} Lista de clientes normalizada.
 * @throws {Error} Si no se puede obtener la URL del servidor o si falla la solicitud.
 */
export const fetchClientesDesdeAPI = async (busqueda: string = ""): Promise<Client[]> => {
  try {
    const serverUrl = await new Promise<string>((resolve, reject) => {
      ServicioURLManager.getUrlServicios((result, error) => {
        if (error || !result?.[0]?.Url) {
          reject("No se pudo obtener la URL del servidor.");
        } else {
          resolve(result[0].Url);
        }
      });
    });
 
    const bodyParams: Record<string, string> = {
      token: getToken(),
      filtro: busqueda || 'AUTO',
      Nivel: '9',
      IDCuenta: "0",
    };

console.log("===========>"+bodyParams);
console.log(bodyParams)

    const response = await fetch(`${serverUrl}/getCuentas`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(bodyParams),
    });

 console.log("ando por aca ==========>")


    const json = await response.json();
console.log(json)


    if (!Array.isArray(json)) return [];

    return json.map((item: any) => ({
      id: String(item.IDCliente),
      name: item.Descripcion || item.name || item.Nombre || 'Sin nombre',
      email: item.mail || item.email || item.Email || '',
      totalPurchases: Number(item.Saldo) || 0,
    }));
  } catch (error) {
    console.error('Error al obtener clientes:', error);
    return [];
  }
};
